/**
 * @fileoverview gRPC-Web generated client stub for fleet
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as shared_pb from './shared_pb';

import {
  AvailabilityOrErrorResponse,
  AvailabilityRequest,
  BulkCancelReservationsRequest,
  CancelReservationRequest,
  CreateReservationOrErrorResponse,
  CreateReservationsRequest,
  GetPastReservationOrErrorResponse,
  GetReservationOrErrorResponse,
  GetReservationRequest,
  NearestAvailabilityByDayOrErrorResponse,
  NearestAvailabilityOrErrorResponse,
  NearestAvailabilityRequest,
  Reservation,
  StationReservationsRequest,
  UpdateReservationRequest} from './reservation_pb';

export class ReservationServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: string; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoGetAvailability = new grpcWeb.AbstractClientBase.MethodInfo(
    AvailabilityOrErrorResponse,
    (request: AvailabilityRequest) => {
      return request.serializeBinary();
    },
    AvailabilityOrErrorResponse.deserializeBinary
  );

  getAvailability(
    request: AvailabilityRequest,
    metadata: grpcWeb.Metadata | null): Promise<AvailabilityOrErrorResponse>;

  getAvailability(
    request: AvailabilityRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: AvailabilityOrErrorResponse) => void): grpcWeb.ClientReadableStream<AvailabilityOrErrorResponse>;

  getAvailability(
    request: AvailabilityRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: AvailabilityOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.ReservationService/GetAvailability',
        request,
        metadata || {},
        this.methodInfoGetAvailability,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.ReservationService/GetAvailability',
    request,
    metadata || {},
    this.methodInfoGetAvailability);
  }

  methodInfoGetNearestAvailability = new grpcWeb.AbstractClientBase.MethodInfo(
    NearestAvailabilityOrErrorResponse,
    (request: NearestAvailabilityRequest) => {
      return request.serializeBinary();
    },
    NearestAvailabilityOrErrorResponse.deserializeBinary
  );

  getNearestAvailability(
    request: NearestAvailabilityRequest,
    metadata: grpcWeb.Metadata | null): Promise<NearestAvailabilityOrErrorResponse>;

  getNearestAvailability(
    request: NearestAvailabilityRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: NearestAvailabilityOrErrorResponse) => void): grpcWeb.ClientReadableStream<NearestAvailabilityOrErrorResponse>;

  getNearestAvailability(
    request: NearestAvailabilityRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: NearestAvailabilityOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.ReservationService/GetNearestAvailability',
        request,
        metadata || {},
        this.methodInfoGetNearestAvailability,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.ReservationService/GetNearestAvailability',
    request,
    metadata || {},
    this.methodInfoGetNearestAvailability);
  }

  methodInfoGetNearestAvailabilityByDay = new grpcWeb.AbstractClientBase.MethodInfo(
    NearestAvailabilityByDayOrErrorResponse,
    (request: NearestAvailabilityRequest) => {
      return request.serializeBinary();
    },
    NearestAvailabilityByDayOrErrorResponse.deserializeBinary
  );

  getNearestAvailabilityByDay(
    request: NearestAvailabilityRequest,
    metadata: grpcWeb.Metadata | null): Promise<NearestAvailabilityByDayOrErrorResponse>;

  getNearestAvailabilityByDay(
    request: NearestAvailabilityRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: NearestAvailabilityByDayOrErrorResponse) => void): grpcWeb.ClientReadableStream<NearestAvailabilityByDayOrErrorResponse>;

  getNearestAvailabilityByDay(
    request: NearestAvailabilityRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: NearestAvailabilityByDayOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.ReservationService/GetNearestAvailabilityByDay',
        request,
        metadata || {},
        this.methodInfoGetNearestAvailabilityByDay,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.ReservationService/GetNearestAvailabilityByDay',
    request,
    metadata || {},
    this.methodInfoGetNearestAvailabilityByDay);
  }

  methodInfoGetReservations = new grpcWeb.AbstractClientBase.MethodInfo(
    GetReservationOrErrorResponse,
    (request: GetReservationRequest) => {
      return request.serializeBinary();
    },
    GetReservationOrErrorResponse.deserializeBinary
  );

  getReservations(
    request: GetReservationRequest,
    metadata: grpcWeb.Metadata | null): Promise<GetReservationOrErrorResponse>;

  getReservations(
    request: GetReservationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetReservationOrErrorResponse) => void): grpcWeb.ClientReadableStream<GetReservationOrErrorResponse>;

  getReservations(
    request: GetReservationRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: GetReservationOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.ReservationService/GetReservations',
        request,
        metadata || {},
        this.methodInfoGetReservations,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.ReservationService/GetReservations',
    request,
    metadata || {},
    this.methodInfoGetReservations);
  }

  methodInfoGetPastReservations = new grpcWeb.AbstractClientBase.MethodInfo(
    GetPastReservationOrErrorResponse,
    (request: GetReservationRequest) => {
      return request.serializeBinary();
    },
    GetPastReservationOrErrorResponse.deserializeBinary
  );

  getPastReservations(
    request: GetReservationRequest,
    metadata: grpcWeb.Metadata | null): Promise<GetPastReservationOrErrorResponse>;

  getPastReservations(
    request: GetReservationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetPastReservationOrErrorResponse) => void): grpcWeb.ClientReadableStream<GetPastReservationOrErrorResponse>;

  getPastReservations(
    request: GetReservationRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: GetPastReservationOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.ReservationService/GetPastReservations',
        request,
        metadata || {},
        this.methodInfoGetPastReservations,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.ReservationService/GetPastReservations',
    request,
    metadata || {},
    this.methodInfoGetPastReservations);
  }

  methodInfoCreateReservations = new grpcWeb.AbstractClientBase.MethodInfo(
    CreateReservationOrErrorResponse,
    (request: CreateReservationsRequest) => {
      return request.serializeBinary();
    },
    CreateReservationOrErrorResponse.deserializeBinary
  );

  createReservations(
    request: CreateReservationsRequest,
    metadata?: grpcWeb.Metadata) {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/fleet.ReservationService/CreateReservations',
      request,
      metadata || {},
      this.methodInfoCreateReservations);
  }

  methodInfoUpdateReservation = new grpcWeb.AbstractClientBase.MethodInfo(
    shared_pb.EmptyOrErrorResponse,
    (request: UpdateReservationRequest) => {
      return request.serializeBinary();
    },
    shared_pb.EmptyOrErrorResponse.deserializeBinary
  );

  updateReservation(
    request: UpdateReservationRequest,
    metadata: grpcWeb.Metadata | null): Promise<shared_pb.EmptyOrErrorResponse>;

  updateReservation(
    request: UpdateReservationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: shared_pb.EmptyOrErrorResponse) => void): grpcWeb.ClientReadableStream<shared_pb.EmptyOrErrorResponse>;

  updateReservation(
    request: UpdateReservationRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: shared_pb.EmptyOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.ReservationService/UpdateReservation',
        request,
        metadata || {},
        this.methodInfoUpdateReservation,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.ReservationService/UpdateReservation',
    request,
    metadata || {},
    this.methodInfoUpdateReservation);
  }

  methodInfoCancelReservation = new grpcWeb.AbstractClientBase.MethodInfo(
    shared_pb.EmptyOrErrorResponse,
    (request: CancelReservationRequest) => {
      return request.serializeBinary();
    },
    shared_pb.EmptyOrErrorResponse.deserializeBinary
  );

  cancelReservation(
    request: CancelReservationRequest,
    metadata: grpcWeb.Metadata | null): Promise<shared_pb.EmptyOrErrorResponse>;

  cancelReservation(
    request: CancelReservationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: shared_pb.EmptyOrErrorResponse) => void): grpcWeb.ClientReadableStream<shared_pb.EmptyOrErrorResponse>;

  cancelReservation(
    request: CancelReservationRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: shared_pb.EmptyOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.ReservationService/CancelReservation',
        request,
        metadata || {},
        this.methodInfoCancelReservation,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.ReservationService/CancelReservation',
    request,
    metadata || {},
    this.methodInfoCancelReservation);
  }

  methodInfoBulkCancelReservations = new grpcWeb.AbstractClientBase.MethodInfo(
    shared_pb.EmptyOrErrorResponse,
    (request: BulkCancelReservationsRequest) => {
      return request.serializeBinary();
    },
    shared_pb.EmptyOrErrorResponse.deserializeBinary
  );

  bulkCancelReservations(
    request: BulkCancelReservationsRequest,
    metadata: grpcWeb.Metadata | null): Promise<shared_pb.EmptyOrErrorResponse>;

  bulkCancelReservations(
    request: BulkCancelReservationsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: shared_pb.EmptyOrErrorResponse) => void): grpcWeb.ClientReadableStream<shared_pb.EmptyOrErrorResponse>;

  bulkCancelReservations(
    request: BulkCancelReservationsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: shared_pb.EmptyOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.ReservationService/BulkCancelReservations',
        request,
        metadata || {},
        this.methodInfoBulkCancelReservations,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.ReservationService/BulkCancelReservations',
    request,
    metadata || {},
    this.methodInfoBulkCancelReservations);
  }

  methodInfoGetStationReservations = new grpcWeb.AbstractClientBase.MethodInfo(
    Reservation,
    (request: StationReservationsRequest) => {
      return request.serializeBinary();
    },
    Reservation.deserializeBinary
  );

  getStationReservations(
    request: StationReservationsRequest,
    metadata?: grpcWeb.Metadata) {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/fleet.ReservationService/GetStationReservations',
      request,
      metadata || {},
      this.methodInfoGetStationReservations);
  }

}

